<script lang="ts">
  import i18n from '../../i18n'
  import { featureFlags } from '../../stores/feature-flags'
</script>

{#if import.meta.env.VITE_APP_ENV && import.meta.env.VITE_APP_ENV !== 'production' && !$featureFlags.demoMode}
  <div class="test-env-banner">
    {$i18n.t('testEnvBanner.message', { env: import.meta.env.VITE_APP_ENV })}
  </div>
{/if}

<style lang="scss">
  .test-env-banner {
    background: var(--color-picker-red);
    color: #fff;
    font-size: 0.5rem;
    left: 0;
    padding: 0.25rem;
    position: fixed;
    right: 0;
    text-align: center;
    top: 0;
    z-index: 10000;
  }
</style>
